module.exports = __webpack_public_path__ + "media/captain-falcon.e9d76caa.wav";